import { daysBetween } from "./dates"

// Chart point N is the stock at the START of day today + N. The server's
// stockout_on is the day stock reaches zero at the END of that day, which is
// the same instant as the start of the next day. The dot sits on the stockout
// day itself so reading it gives the date the summary card shows. Null when
// there is no stockout or it falls outside the plotted days.
export function stockoutDotDay(today: string, stockoutOn: string | null, lastDay: number): number | null {
  if (!stockoutOn) return null
  const day = daysBetween(today, stockoutOn)
  return day >= 0 && day <= lastDay ? day : null
}
